import { createContext, useState, PropsWithChildren } from "react";

type Theme = "light" | "dark";

type ThemeContextType = {
  theme: Theme;
  toggleTheme: () => void;  
};

const ThemeContext = createContext({} as ThemeContextType);

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState<Theme>(() => {   
    const storedTheme = localStorage.getItem("theme");
    if (!storedTheme){
      localStorage.setItem("theme", "dark");
      document.documentElement.setAttribute("data-theme", "dark");
    }
    return ((storedTheme ?? "dark") as Theme);
  });  

  const toggleTheme = () => {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme === "light") {
      setDark();
      setTheme("dark");
    } else {
      setLight();
      setTheme("light");
    }
  };

  const setDark = () => {
    localStorage.setItem("theme", "dark");
    document.documentElement.setAttribute("data-theme", "dark");
  };

  const setLight = () => {
    localStorage.setItem("theme", "light");
    document.documentElement.setAttribute("data-theme", "light");
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
